<div [@slideInTop] class="navb"><app-navigation-bar></app-navigation-bar></div>

<section class="container-md px-0">
  <div class="hero-container">
    <div class="mobile-img-container">
      <img src="../../assets/images/1620041573181-removebg-preview.png" alt="" class="img-fluid" />
    </div>
    <div [@slideInRight] class="desktop-img-container d-none">
      <img src="../../assets/images/1620041573181-removebg-preview.png" alt="" class="img-fluid" />
    </div>
    <div class="info-container mt-5">
      <div [@income]>
        <h1 class="display-5 text-center fw-bold mb-3 mobile-heading">
          MYLEV - финансов асистент
        </h1>
        <div class="desktop-heading d-none">
          <h1 class="display-5 text-left fw-bold m-0">MYLEV</h1>
          <h2 class="display-5 text-left fw-bold mb-3">финансов асистент</h2>
        </div>
        <p>
          Проследете вашите приходи и разходи. Разберете къде отиват вашите пари, задайте си цел и оптимизирайте бюджета
          си.
        </p>
        <button [routerLink]="['/features']" class="learn-more-btn">Научи повече</button>
      </div>
      <div class="logo-container">
        <div class="mx-2">
          <img src="../../assets/images/OpenAI_Logo.svg.png" alt="" style="height: 24px;" class="img-fluid" />
        </div>
        <div class="mx-2">
          <img src="../../assets/images/chartjs-removebg-preview.png" alt="" style="height: 34px;" class="img-fluid" />
        </div>
        <div class="mx-2">
          <img src="../../assets/images/Heroku_logo.svg.png" alt="" style="height: 30px;" class="img-fluid" />
        </div>
        <div class="mx-2">
          <img src="../../assets/images/apilayer.png" alt="" style="height: 24px;" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</section>

<section [@income] class="hero">
  <h2>Добре дошли в MYLEV - финансов асистент</h2>
  <p>
    Ние Ви помагаме да управлявате по-добре финансите си, като предоставяме информация за вашите
    приходи и разходи.
  </p>
  <button class="learn-more-btn" [routerLink]="['/login']" [queryParams]="{ variable: register }">Започни
    сега</button>
</section>

<section id="features" #features class="container-md px-0 pt-4">
  <h2 class="center p-4">Функции които предлага MYLEV</h2>
  <div class="feature-container">
    <div class="feature" appInView (inView)="slideFromLeft($event)">
      <i class="fa fa-money"></i>
      <h3 class="featureTitle">Проследявайте разходите си</h3>
      <p>MYLEV улеснява наблюдението на вашите разходи и оставането в рамките на бюджета Ви.</p>
    </div>
    <div class="feature" appInView (inView)="onInView($event)">
      <i class="fa fa-line-chart"></i>
      <h3 class="featureTitle">Анализирайте финансите си</h3>
      <p>Получавайте подробни отчети и информация за вашите навици за харчене и финансово състояние.</p>
    </div>
    <div class="feature" appInView (inView)="slideFromRight($event)">
      <i class="fa fa-mobile"></i>
      <h3 class="featureTitle">Управлявайте акаунтите си в движение</h3>
      <p>Достъп до вашата финансова информация и управление на вашите сметки от вашето мобилно устройство.</p>
    </div>
  </div>
</section>


<!-- <section #whayToUse [@fadeIn]="elementRef.nativeElement.classList.contains('in-view') ? 'in' : 'out'"
  class="features px-0 pt-4"> -->

<section #whayToUse class="features px-0 pt-4">
  <div class="container-md">
    <h3>Защо да използвам MYLEV ?</h3>
    <ul>
      <li appInView (inView)="slideFromLeft($event)">Проследявайте приходите и разходите си</li>
      <li appInView (inView)="slideFromRight($event)">Анализирайте категориите на разходите си</li>
      <li appInView (inView)="slideFromLeft($event)">Създавайте бюджети и цели за спестяване</li>
      <li appInView (inView)="slideFromRight($event)">Получавайте персонализирани финансови съвети</li>
    </ul>
  </div>
</section>

<section class="how-it-works container-md" #howItWorks>
  <h2>Как работи MYLEV ?</h2>
  <p>MYLEV финансов асистент е предназначен да Ви помогне да управлявате вашите финанси лесно и ефективно. Ето как
    работи:</p>

  <div class="step" appInView (inView)="slideFromRight($event)">
    <div class="step-image">
      <img src="../../assets/images/step1.jpg" alt="Step 1">
    </div>
    <div class="step-text">
      <h3>Стъпка 1: Създайте вашия акаунт</h3>
      <p>Създайте вашия персонален акаунт в MYLEV и започнете да го персонализирате по ваш избор. Проследявайте
        финансите
        си по всяко време, където и да сте!</p>
    </div>
  </div>

  <div class="step" appInView (inView)="slideFromLeft($event)">
    <div class="step-image">
      <img src="../../assets/images/step-2.jpg" alt="Step 2">
    </div>
    <div class="step-text">
      <h3>Стъпка 2: Добавете вашите трансакции</h3>
      <p>Имате възможност да добавяте трансакции, които съдържат име, стойност, дата и тип. Не се тревожете ако объркате
        нещо, защото има възможност за редакция след това ;)</p>
    </div>
  </div>

  <div class="step" appInView (inView)="slideFromRight($event)">
    <div class="step-image">
      <img src="../../assets/images/step-3.jpg" alt="Step 3">
    </div>
    <div class="step-text">
      <h3>Стъпка 3: Прегледайте статиската за вашите разходи и трансакции</h3>
      <p>Можете да прегледате всички ваши трансакции/разходи по категории и да направите своя план за
        оптимизирането на вашите пари, като зададете цел.</p>
    </div>
  </div>

  <div class="step" appInView (inView)="slideFromLeft($event)">
    <div class="step-image">
      <img src="../../assets/images/step4.jpg" alt="Step 4">
    </div>
    <div class="step-text">
      <h3>Стъпка 4: Разпечатайте вашите отчети</h3>
      <p>Имате възможност да свалите вашите отчети за избран от вас преиод и да ги зпазите за постоянно в подходящ за
        анализи формат. Възползвайте се от това! </p>
    </div>
  </div>
</section>

<section class="slider" appInView (inView)="onInView($event)">
  <input type="radio" name="slider" title="slide1" checked="checked" class="slider__nav" />
  <input type="radio" name="slider" title="slide2" class="slider__nav" />
  <input type="radio" name="slider" title="slide3" class="slider__nav" />
  <input type="radio" name="slider" title="slide4" class="slider__nav" />
  <div class="slider__inner">
    <div class="slider__contents"><i class="slider__image fa fa-bank"></i>
      <h2 class="slider__caption">Не бъди зависим от банката</h2>
      <p class="slider__txt">Управлявайте вашите средства без никакви ограничения и такси от вашата банка!</p>
    </div>
    <div class="slider__contents"><i class="slider__image fa fa-calendar"></i>
      <h2 class="slider__caption">Ораганизирай нещата както ти пожелаеш</h2>
      <p class="slider__txt">Организирайте разписките за вашите сметки!</p>
    </div>
    <div class="slider__contents"><i class="slider__image fa fa-bar-chart"></i>
      <h2 class="slider__caption">Виж нагледно къде отиват парите ти</h2>
      <p class="slider__txt">Разберете за какво си харчите парите с помощта на графиките, таблиците и статистиките които
        получавате!</p>
    </div>
    <div class="slider__contents"><i class="slider__image fa fa-diamond"></i>
      <h2 class="slider__caption">Изкуствен интелект</h2>
      <p class="slider__txt">Възползвайте се от функцията "Помощник", която представлява изкуствен интелект от OPEN AI,
        който ще
        отговори на вашите въпроси!</p>
    </div>
  </div>
</section>

<section class="contact container-md">
  <h2 class="center pt-5">Напишете вашето съобщение или препоръка към нас</h2>
  <div class="background">
    <div class="container" appInView (inView)="fadeIn($event)">
      <div class="screen">
        <div class="screen-header">
          <div class="screen-header-left">
            <div class="screen-header-button close"></div>
            <div class="screen-header-button maximize"></div>
            <div class="screen-header-button minimize"></div>
          </div>
          <div class="screen-header-right">
            <div class="screen-header-ellipsis"></div>
            <div class="screen-header-ellipsis"></div>
            <div class="screen-header-ellipsis"></div>
          </div>
        </div>
        <div class="screen-body">
          <div class="screen-body-item">
            <div class="app-form">
              <h3 style="text-align: center; color: white">При въпроси и проблеми, моля свържете се с нас!</h3>
              <br>
              <div class="app-form-group">
                <span style="font-size: 18px; color:#e8e925"><b>Email:</b> info@mylev.com</span>
              </div>
              <div class="app-form-group">
                <span style="font-size: 18px; color:#74c54f"><b>Телефон:</b> +359 988 71 6362</span>
              </div>
              <div class="app-form-group message">
                <span style="font-size: 18px; color:#9d345f"><b>Адрес:</b> Димитър Найденов 100, Велико Търново,
                  България</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section #reviews id="reviews" class="container-md px-0">
  <h2 class="center pb-4">Какво мислят хората за MYLEV ?</h2>
  <div class="reviews-container">
    <div class="review-card" appInView (inView)="slideFromLeft($event)">
      <div class="review-content">
        <p class="review-text">"От както използвам това приложение, осъзнавам къде са ми били пропуските при опитите ми
          да спестя повече пари от заплатата си."</p>
        <p class="review-author">- Десислава Илиева</p>
      </div>
    </div>

    <div class="review-card" appInView (inView)="onInView($event)">
      <div class="review-content">
        <p class="review-text">"Не съм използвал до сега такъв тип финансова "помощ", но определно има ефект и според
          мен всеки трябва да знае къде отиват и за какво отиват парите му до сототинка."</p>
        <p class="review-author">- Иван Тодоров</p>
      </div>
    </div>

    <div class="review-card" appInView (inView)="slideFromRight($event)">
      <div class="review-content">
        <p class="review-text">"Използвам MYLEV едва от един месец и веднага усетих удобстовото което предлага
          апликацията. Самият факт, че мога по всяко време да добавя нови записи в профила си и да видя графика с това
          за
          какво харча най-много е супер."</p>
        <p class="review-author">- Валентин Костадинов</p>
      </div>
    </div>
  </div>
</section>

<footer appInView (inView)="onInView($event)">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h3>За нас</h3>
        <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да има
          контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да получите подробна
          информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
      </div>
      <div class="col-md-3">
        <h3>За връзка</h3>
        <ul>
          <li>Димитър Найденов 100</li>
          <li>Велико Търново, България</li>
          <li>Email: info@mylev.com</li>
        </ul>
      </div>
      <div class="col-md-3">
        <h3>Последвайте ни в</h3>
        <ul>
          <li><a href="#">Facebook</a></li>
          <li><a href="#">Twitter</a></li>
          <li><a href="#">Instagram</a></li>
          <li><a href="#">LinkedIn</a></li>
        </ul>
      </div>
    </div>
    <hr>
    <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
  </div>
</footer>